module.exports = __webpack_public_path__ + "img/loading-icon.acbf0368.gif";